export enum FacturationPath {
  ROOT = '',
  LISTE = 'liste_factures',
  RELANCES = 'relances',
  TRAITEMENT = 'traitement',
  EDITION = 'edition',
  ID_FACTURE_PARAM = 'idFacture',
  GENERAL = 'general',
  PAIEMENTS = 'paiements',
  CANCEL_DIALOG = 'cancel_dialog',
  FACTURES = 'factures',
  EDITION_BROUILLON = 'edition-brouillon',
}
